module.exports = __webpack_public_path__ + "img/icon_sportMenu_basketball.6fb3f3a9.svg";